import React from 'react';

import { SelectCustomizable } from 'core/chatbot/components/atoms/legacyAtoms';
import MultiSelectWithCheckbox from '../../../components/atoms/MultiSelectWithCheckbox/MultiSelectWithCheckbox';

import type { SelectOption } from '../useRadarView';

import './_radar-filters.scss';

/**
 * RadarFilters - Group and category filters shown in the radar header actions slot.
 */

type RadarFiltersProps = {
  allGroupsLabel: string;
  categoryAriaLabel: string;
  categoryOptions: SelectOption[];
  groupOptions: SelectOption[];
  groupsPlaceholder: string;
  onCategoryChange: (option: SelectOption | null) => void;
  onGroupsChange: (options: SelectOption[] | null, meta?: { action?: string }) => void;
  selectedCategory: SelectOption;
  selectedGroupOptions: SelectOption[];
};

function RadarFilters({
  allGroupsLabel,
  categoryAriaLabel,
  categoryOptions,
  groupOptions,
  groupsPlaceholder,
  onCategoryChange,
  onGroupsChange,
  selectedCategory,
  selectedGroupOptions,
}: Readonly<RadarFiltersProps>): JSX.Element {
  return (
    <div className="radar-filters">
      <MultiSelectWithCheckbox
        allSelectedLabel={allGroupsLabel}
        ariaLabel={groupsPlaceholder}
        maxVisibleValues={1}
        onChange={onGroupsChange}
        options={groupOptions}
        placeholder={groupsPlaceholder}
        value={selectedGroupOptions}
      />
      <SelectCustomizable
        aria-label={categoryAriaLabel}
        onChange={onCategoryChange}
        options={categoryOptions}
        size="default"
        value={selectedCategory}
        variant="default"
      />
    </div>
  );
}

export default RadarFilters;
